<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Requisições de Clientes</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Nova Requisição</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="requisicoes"
          :total="total"
          :hideSearch="true"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import requisicaoService from '@/services/requisicao'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'

export default {
  name: 'requisicoes',
  components: {
    EDataTable
  },
  data () {
    return {
      requisicoes: [],
      total: 0,
      headers: [
        { text: 'Data', value: 'data_lancto', sortable: false },
        { text: 'Empresa', value: 'empresa', sortable: false },
        { text: 'Veículo', value: 'veiculo', sortable: false },
        { text: 'Descrição', value: 'plano', sortable: false },
        { text: 'Total', value: 'valor_total', sortable: false },
        { text: 'Baixa', value: 'baixado', sortable: false }],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },
  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await requisicaoService.getAllCliente(page) : await requisicaoService.getByNome(search, page)
        this.total = result._meta.total_items
        this.requisicoes = result.data
      } catch (error) {
        this.viagens = []
        showError(error)
      }
    },
    editItem (item) {
      if (item.baixado === 'S') {
        showError('Requisição já baixada por ' + item.usuario_baixa)
        return
      }
      var ret = retPermissao('Requisições Cliente', 'alterar')
      if (ret === true) {
        // this.$router.push(`/requisicoes/editar/${item.id}`)
        this.$router.push(`/requisicoescliente/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      if (item.baixado === 'S') {
        showError('Requisição já baixado por ' + item.usuario_baixa)
        return
      }
      // var ret = retPermissao('Requisições Cliente', 'excluir')
      // if (ret === true) {
      showConfirm(`Tem certeza que deseja remover requisição ?`, async result => {
        if (result) {
          try {
            this.loading = true
            await requisicaoService.delete(item.id)
            this.getAll(1, '')
          } catch (error) {
            showError(error)
          } finally {
            this.loading = false
          }
        }
      })
    // }
    },
    async onNewButtonClick () {
      var result5 = await requisicaoService.getByEmpresasHabilitadas()
      if (result5.data === undefined) {
        showError('Não localizei empresa habilitada!!!')
        return
      }
      this.$router.push(`/requisicoescliente/criar`)
    }
  }
}
</script>
